// Formats de documents (sprint 5) : module minuscule du bundle initial (skeleton,
// pictogramme, message de rapport). La lecture des spécifications (documentSpec.js)
// est dans le chunk de la carte et de la visionneuse.
// Format → libellés, extension et classe de couleur (tokens --ds-doc-<format>-*)
export const DOCUMENT_FORMATS = {
  pdf: { key: 'pdf', label: 'PDF', long: 'Document PDF', ext: 'pdf', unit: 'page' },
  docx: { key: 'docx', label: 'Word', long: 'Document Word', ext: 'docx', unit: 'page' },
  xlsx: { key: 'xlsx', label: 'Excel', long: 'Classeur Excel', ext: 'xlsx', unit: 'feuille' },
  pptx: { key: 'pptx', label: 'PowerPoint', long: 'Présentation PowerPoint', ext: 'pptx', unit: 'diapositive' },
  csv: { key: 'csv', label: 'CSV', long: 'Fichier CSV', ext: 'csv', unit: 'ligne' },
};

export const FORMAT_ORDER = ['pdf', 'docx', 'xlsx', 'pptx'];


/** Spécification du document dans la réponse de POST /api/reports/compose (formes tolérées). */
export function documentFromResponse(data) {
  if (!data || typeof data !== 'object') return null;
  const spec = data.document ?? data.artifact?.spec ?? data.spec ?? (data.kind === 'document' ? data : null);
  return spec && typeof spec === 'object' ? spec : null;
}
